import {OnBaseDocumentData} from '../types/OnBaseDocumentData'
import {useEffect, useState} from 'react'
import { GetOnBaseDocumentsRequest } from '../types/GetOnBaseDocumentsRequest';  

function useGetOnBaseDocuments(params: GetOnBaseDocumentsRequest, refresh: number )
{
   const [loading, setLoading] = useState(false);
   const [Data, setData] = useState<OnBaseDocumentData[]>([]);

   useEffect(() => {

    const fetchOnbaseDocuments = async () => {
      
      try {
      
        console.log("fetching onbase documents");
        const baseURL = process.env.REACT_APP_ONBASE_SUPPORT_API_URL;
        const endURL = '/api/GetOnBaseDocuments';

        const response = await fetch(
          baseURL + endURL,
          {
            headers: {'Content-Type': 'application/json'},
            method: "POST",
            body: JSON.stringify(params)
          }
        );
        if (response.ok) {
          const data = await response.json();
          setData(data);
        } else {
          throw new Error('Error Retrieving OnBase Documents List');
        }
      } catch (error) {
        console.error('Error Retrieving OnBase Documents List:', error);
      }
    };

    fetchOnbaseDocuments();
  }, [refresh]);

   
    return {Data, loading}

}

export default useGetOnBaseDocuments;